import { Link, Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { ShieldAlert } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { sessionQuery, useAuthenticatedSession } from '@/lib/session';

export const Route = createFileRoute('/_app/admin')({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(sessionQuery);
    if (!session.authenticated || !session.user.isAdmin) throw redirect({ to: '/' });
  },
  component: AdminLayout,
});

function AdminLayout() {
  const { twoFactorSetupRequired } = useAuthenticatedSession();
  return (
    // Admin sections live in the app sidebar.
    <div className="min-w-0">
      <div>
        {twoFactorSetupRequired ? (
          <Alert>
            <ShieldAlert />
            <AlertTitle>Two-factor authentication required</AlertTitle>
            <AlertDescription className="grid gap-3">
              This panel requires administrators to enable two-factor authentication before using
              the admin area.
              <Button asChild size="sm" className="w-fit">
                <Link to="/account/security">Set it up</Link>
              </Button>
            </AlertDescription>
          </Alert>
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
}
